import { useNoFilterCarFinished } from './events/noFilterCounters/useNoFilterCarFinished'
import { useNoFilterItemDelete } from './events/noFilterCounters/useNoFilterItemDelete'
import { useNoFilterItemPublish } from './events/noFilterCounters/useNoFilterItemPublish'
import { useNoFilterItemWithdraw } from './events/noFilterCounters/useNoFilterItemWithdraw'

export const NO_FILTER_SOCKET_CALLBACK = 'no-filter-counters-update'

export function useNoFilterCountersSocket() {
  const { itemPublish } = useNoFilterItemPublish()
  const { itemWithdraw } = useNoFilterItemWithdraw()
  const { itemDelete } = useNoFilterItemDelete()
  const { carFinished } = useNoFilterCarFinished()

  const init = () => {
    itemPublish()
    itemWithdraw()
    itemDelete()
    carFinished()
  }

  return { init }
}
